// App
import React from 'react';

// Constellation
import { Box, Icon, Image, Text } from '@zillow/constellation-10';
import { IconPhotosOutline } from '@zillow/constellation-icons';

// Types
type BubbleWindowPropTypes = {
  propertyPhotos: Array<{ medium: string }> | null;
  beds: number | null;
  baths: number | null;
  sqft: string | null;
  bubblePrice: string | null;
};
/**
 * BubbleWindow is the child component of zilow-map-control bubbles. When a marker is hovered,
 * the zrc bubble will render the info window that contains home listing information.
 */
const BubbleWindow = ({ propertyPhotos, beds, baths, sqft, bubblePrice }: BubbleWindowPropTypes) => {
  const propertyPhoto = propertyPhotos && propertyPhotos[0] && propertyPhotos[0].medium;

  return (
    <Box css={{ background: 'bg.neutral', boxShadow: 'smHeavy', width: '136px' }}>
      <Box css={{ display: 'flex', flexDirection: 'row', padding: '200' }}>
        <Box
          css={{
            display: 'flex',
            height: '1200',
            width: '1200',
            overflow: 'hidden',
            background: 'bg.soft',
            justifyContent: 'center',
            alignItems: 'center',
            marginRight: '200',
          }}
        >
          {propertyPhoto ? (
            <Image
              src={propertyPhoto}
              alt="property thumbnail"
              css={{ height: '1200', width: '1200', objectFit: 'cover' }}
            />
          ) : (
            <Icon render={<IconPhotosOutline />} size="lg" css={{ color: 'icon.action.disabled' }} />
          )}
        </Box>
        <Box css={{ display: 'flex', flexDirection: 'column' }}>
          <Text textStyle="body-xs-bold" css={{ lineHeight: '16px !important' }}>
            {bubblePrice}
          </Text>
          <Text textStyle="body-xs" css={{ lineHeight: '16px !important' }}>
            {beds} bed, {baths} ba
          </Text>
          <Text textStyle="body-xs" css={{ lineHeight: '16px !important' }}>{`${sqft ? sqft : '—'} sq. ft.`}</Text>
        </Box>
      </Box>
    </Box>
  );
};

export default BubbleWindow;
